import { call } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { NetworkBarStreamTypes } from './types';
import {
  PapiRequestDaSharedNetworkbarUpdateSection,
  PapiDaSharedNetworkbarUpdateSection,
  PapiDaSharedNetworkbarUnrecommendgroup,
  PapiDaSharedNetworkbarUnpingroup,
  PapiDaSharedNetworkbarPingroup,
  PapiDaSharedNetworkbar,
} from '@wix/da-papi-types';

function getFakeGroups(content_type?: NetworkBarStreamTypes, cursor?: any) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require
    const groups = require('@wix/da-sample-data').groups;
    const offset = Number(cursor ?? 0);
    const pinned = groups.slice(0, 2).map(group => ({
      ...group,
      isWatching: true,
      networkbar: {
        isPinned: true,
        hasNewContent: Math.random() > 0.8,
      },
    }));
    const watched = groups.slice(2).map(group => ({
      ...group,
      isWatching: true,
      networkbar: {
        isPinned: false,
        hasNewContent: Math.random() > 0.8,
      },
    }));

    const fetchWatched = content_type !== 'recommended_groups';
    const fetchRecommended = content_type !== 'watched_groups';
    const watchedGroups = fetchWatched
      ? {
          groups: [...pinned, ...watched].slice(offset, offset + 5),
          hasMore: groups.length > offset + 5,
          cursor: offset + 5,
        }
      : undefined;
    const recommendedGroups = fetchRecommended
      ? {
          groups: groups
            .slice(offset, 3)
            .map((group, idx) => ({
              ...group,
              userId: group.userId + 10000000,
            }))
            .map(group => ({ ...group, isWatching: false })),
          hasMore: groups.length > offset + 3,
          cursor: offset + 3,
        }
      : undefined;

    return {
      mainNavNewItem: ['dyw'],
      watchedGroups,
      recommendedGroups,
    };
  }

  return {};
}

export function* fetchGroups(
  content_type?: NetworkBarStreamTypes,
  cursor?: string
) {
  const result: PapiDaSharedNetworkbar | false = yield call(
    requestPuppy,
    {
      method: 'get',
      url: '/networkbar',
      params: { cursor, content_type, expand: 'user.networkbar,user.watch' },
    },
    () => getFakeGroups(content_type, cursor)
  );

  return result;
}

export function* doPinGroup(userid: number) {
  const result: PapiDaSharedNetworkbarPingroup | false = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/networkbar/pingroup',
      data: { userid },
    },
    () => ({ success: true })
  );

  return result;
}

export function* doUnpinGroup(userid: number) {
  const result: PapiDaSharedNetworkbarUnpingroup | false = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/networkbar/unpingroup',
      data: { userid },
    },
    () => ({ success: true })
  );

  return result;
}

export function* doUnrecommendGroup(userid: number) {
  const result: PapiDaSharedNetworkbarUnrecommendgroup | false = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/networkbar/unrecommendgroup',
      data: { userid },
    },
    () => ({ success: true })
  );

  return result;
}

export function* doToggleSection(
  section: NetworkBarStreamTypes,
  isFoldedNow: boolean
) {
  const data: PapiRequestDaSharedNetworkbarUpdateSection = {
    content_type: section,
    is_collapsed: isFoldedNow,
  };
  const result: PapiDaSharedNetworkbarUpdateSection | false = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/networkbar/update_section',
      data,
    },
    () => ({ success: true })
  );

  return result;
}
